import React, { useState, useEffect } from 'react';
import { Form, Input, Typography, Button } from 'antd';
import styled from 'styled-components';
import container from 'container/BrokerDashboard/editAgentContainer';

const { Title } = Typography;

const SectionHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 24px;
`;

const AssistantInfoSection = ({ getOnboardingAssistantInfoResponse }) => {
  const { data: assistantInfo } = getOnboardingAssistantInfoResponse || {};
  const [form] = Form.useForm();
  const [isEditable, setIsEditable] = useState(false);

  useEffect(() => {
    if (assistantInfo) {
      form.setFieldsValue({
        fullName: assistantInfo.fullName || '',
        phoneNumber: assistantInfo.phoneNumber || '',
        email: assistantInfo.email || '',
      });
    }
  }, [assistantInfo, form]);

  const handleToggle = async () => {
    if (isEditable) {
      try {
        const values = await form.validateFields();

        const payload = {
          fullName: values.fullName,
          phoneNumber: values.phoneNumber,
          email: values.email,
        };

        console.log('Assistant Info Payload:', payload);
        // API call can go here

        setIsEditable(false);
      } catch (error) {
        console.warn('Validation Failed:', error);
      }
    } else {
      setIsEditable(true);
    }
  };

  return (
    <div>
      <SectionHeader>
        <Title level={4}>Assistant Information</Title>
        <Button type="link" onClick={handleToggle}>
          {isEditable ? 'Save' : 'Edit'}
        </Button>
      </SectionHeader>

      <Form layout="vertical" form={form}>
        <Grid>
          <Form.Item
            label="Full name"
            name="fullName"
            rules={[{ required: true, message: 'Please enter full name' }]}
          >
            <Input placeholder="Andrew Garfield" disabled={!isEditable} />
          </Form.Item>

          <Form.Item
            label="Phone number"
            name="phoneNumber"
            rules={[{ required: true, message: 'Please enter phone number' }]}
          >
            <Input placeholder="214 442 2235" disabled={!isEditable} />
          </Form.Item>

          <Form.Item
            label="Email address"
            name="email"
            rules={[
              { required: true, message: 'Please enter email' },
              { type: 'email', message: 'Please enter a valid email' },
            ]}
          >
            <Input placeholder="andrew@email.com" disabled={!isEditable} />
          </Form.Item>
        </Grid>
      </Form>
    </div>
  );
};

export default container(AssistantInfoSection);
